// Идея https://www.joshwcomeau.com/react/modern-spacer-gif/
// Дополнительно: если опустить параметр size включится стиль flex: 1 для заполнения пустого пространнства во flexbox

import styled, { css } from 'styled-components';

enum Axis {
	Horizontal,
	Vertical,
}

interface Props {
	size?: number;
	inline?: boolean;
	axis?: Axis;
}

function getHeight({ axis, size }: Props) {
	return axis === Axis.Horizontal ? 1 : size;
}
function getWidth({ axis, size }: Props) {
	return axis === Axis.Vertical ? 1 : size;
}

const Spacer = styled.span<Props>`
	display: ${({ inline }) => (inline ? 'inline-block' : 'block')};

	${(props) =>
		props.size &&
		css`
			width: ${getWidth}px;
			min-width: ${getWidth}px;
			height: ${getHeight}px;
			min-height: ${getHeight}px;
		`}

	${(props) =>
		!props.size &&
		css`
			flex: 1;
		`}
`;

export default Spacer;
